import { Component, OnDestroy, OnInit } from '@angular/core';
import {RequestMoneyService} from '../request-money/request-money.service'
@Component({
  selector: 'app-request-money',
  templateUrl: './request-money.component.html',
  styleUrls: ['./request-money.component.scss']
})
export class RequestMoneyComponent implements OnInit, OnDestroy {

  constructor(public requestMoneyervice:RequestMoneyService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(){
    this.requestMoneyervice.resetCheckedSteps()
  }



}
